export enum SkillLevel {
	VeryGood = "VeryGood",
	Good = "Good"
}
